<template>
    <h5>Modificar Canal</h5>
    <Form role="form" class="text-start mt-4" :validation-schema="schema" @submit="handleEditaCanal">

        <soft-field type="text" id="nombre" v-model="canal.nombre" :useLabel="true" label="Nombre" name="nombre" class="mb-2 label-input2" largo="80"/>

       <!-- BOTONES -->
        <div class="q-flex-between q-mar-top q-actions">

        <button
            type="button"
            class="btn-q-secondary"
            @click="$emit('cerrar-modal')"
            >
            Volver
        </button>

        <button
            type="submit"
            class="btn-q-primary"
            :disabled="loading"
        >
            <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            <span v-else>Confirmar</span>
        </button>

        </div>
    </Form>
  </template>

  <script>
  import SoftField from "@/components/SoftField.vue";

  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  import * as yup from "yup";

  export default {
    name: "EditaCanalForm",
    components: {
        SoftField,
        Form,
    },
    props: {
        canalId: Number,
        canalEstado: String,
        canalUuid: String,
        canalNombre: String
    },
    data() {
        const schema = yup.object().shape({
            nombre: yup.string().required("El nombre es necesario!").max(80,'El tamaño máximo es de 80 caracteres'),
        });

        return {
            loading: false,
            canal:{
                id: this.canalId,
                nombre: this.canalNombre,
                estado: this.canalEstado,
                uuid: this.canalUuid
            },
            schema,
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        async handleEditaCanal() {
            // Aquí puedes realizar acciones cuando se envía el formulario
            this.loading = true;
            try {
                const resp = await this.$store.dispatch("auth/guardaCanal", this.canal);
                this.loading = false;
                if (resp.res=='OK') {
                    showSwal.methods.showSwal({
                        type: "success",
                        message: "Se ha actualizado el canal",
                        width: 400,
                    });
                    this.$emit('cerrar-modal',resp);
                }
                else {
                    showSwal.methods.showSwal({
                        type: "error",
                        message: resp.mensaje,
                        width: 500
                    });
                }
            } catch (error) {
                this.loading = false;
                showSwal.methods.showSwal({
                    type: "error",
                    message: error.response?.data?.mensaje || "Se ha producido un error",
                    width: 500,
                });
            }
        },
    },
  };
  </script>

  <style scoped>
  /* ======= BOTONES FORM RESPONSIVE ======= */

.q-mar-top {
  margin-top: 1rem;
}

.q-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.btn-q-primary,
.btn-q-secondary {
  min-width: 180px;
  height: 48px;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn-q-primary {
  background: var(--q-gold);
  color: var(--q-gold-on);
}

.btn-q-secondary {
  background: var(--q-hover);
  color: var(--q-text);
}

/* Mobile */
@media (max-width: 768px) {
  .q-flex-between {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-q-primary,
  .btn-q-secondary {
    width: 100%;
  }

  .q-actions {
    position: sticky;
    bottom: 0;
    background: var(--q-card);
    padding: 12px 0 calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid var(--q-border);
    z-index: 3;
  }
}
  </style>
